import React, { memo } from "react";
import { getSdk } from "../../services/sdkService";
import {
  CAROUSEL_TYPES,
  withFocusable,
  Loading,
  ModalSettings,
  Button,
  Toast,
  Text,
  AirRemoteArrows
} from "../../services/visualLibraryService";
import { goToDetailPageByProgramType } from "../../utils/goToDetailPage";
import {
  LayoutStyled,
  ButtonStyled,
  ArrowScrollStyled,
  ShadowLayoutStyled,
  LayoutEmptyStyled,
  LayoutDownArrow,
  LayoutUpArrow,
  HeroBanner,
  ContainerStyled,
  ImageBannerStyled,
  TextStyled,
  ContainerButtonStyled,
  ButtonModalStyled,
  IconStyled
} from "./styles/Styled";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { playHandler, play } from "../../utils/mediaDataRetrieval";
import { getLocaleFromLocalCache } from "../../services/localeCacheService";
import getBrands from "../../services/layoutService";
import { getSavedFocusInfo, removeSavedFocusInfo, saveFocusInfo } from "../../services/layoutService";
import getSportsAddons from "../../services/sportPackageService";
import {
  isUserSubscribedToChannel,
  isAddonContent,
  getBrandName,
  getBrandLogoUrl,
  isStarzPlaySubscription,
  isChampionsTrophyFlow
} from "../../utils/subscriptionUtils";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { withAppState, getAppState } from "../../state";
import { i18n, directions } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { CellMeasurer, CellMeasurerCache, List } from "react-virtualized";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { defaultFocusPath as mediaControlFocusPath } from "../../components/MediaControlsList";
import { config } from "../../config/config";
import throttle from "../../helpers/throttle";
import {
  trackPage,
  trackEvent,
  getLayoutEventLabel,
  trackEventPushData,
  trackEventInitializeData
} from "../../services/analyticsService";
import { resolution } from "../../config/ui/resolutionConfig";
import { routes } from "../../routes";
import {
  showNotLoggedModal,
  showExpiredContentModal,
  showSignupPremiumPrompt,
  showContentNotAccessibleModal
} from "../../services/modalsService";
import {
  sameLayoutRequestIsInProgress,
  setLayoutRequestInProgress,
  unsetLayoutRequestInProgress
} from "./layoutNetworkUtils";
import { starzRevamp as Theme } from "starz-visual-themes";
import { sections } from "../../routes";
import { getPath } from "../../utils/getPath";
import { findFromBrands } from "../../helpers/find";
import { getNavigationReferences } from "../../services/navigationService";
import MediaControlsList from "../../components/MediaControlsList/MediaControlsList";
import getMediaItems from "../../components/MediaControlsList/mediaItems";
import { getCacheGeneratedImage } from "../../utils/staticCache";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { ButtonStyled as ModalButtonStyled } from "../../components/ModalSettings/styles/Styled";
import {
  expiredContent,
  isTVODContent,
  isSVODContent,
  isTVODPriority,
  isContentActive,
  tvodTimeExpire,
  pramsYouborra,
  getBuyBrandsInfoObj,
  setCurrentStatusForPlayerObj,
  getBuyBrandsInfoObjChampionsTrophy,
  CHAMPIONS_TROPHY,
  CRICLIFE,
  isADMNContent,
  getSectionName,
  isADMNRoute,
  isAVOD,
  isSVOD
} from "../../utils/tvodUtils";
import { getMultiTaggedAddOnContent } from "../../utils/addOnsUtil";
import { isAvodAssets } from "../../services/titleDataService";
import { showSubscriptionModal } from "../../utils/subscriptionUtils";
import * as Sentry from "@sentry/browser";
import {
  sendCarouselClickEventDataForBytePlus,
  sendVideoPlayClickEventDataForBytePlus,
  sendTrueViewImpressionForBytePlus,
  getParamsForPredictCall
} from "../../services/byteEventService";
import StickyLabel from "../../components/StickyLabel";
import { getStickyLabelForCurrentLayout } from "../../utils/layoutStickyLabelUtil";
import { isHidePromptForKidsProfile } from "../../utils/promptUtils";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { getSponsorBug, impressionTracking } from "../../services/sponsorAdService";

const noHeader = url => url.search(/\/brands\/.*?(?=$|\/$)/) === 0;

const YEAR_CONST = 2018;
const starzplay = "starzplay";

const NO_HEADER_MARGIN_TOP_IN_PX = 196; // 10.2rem top margin if no hero carousel

const MediaControlsListFocus = withFocusable(MediaControlsList);
const ButtonBannerFocus = withFocusable(ButtonModalStyled);

const PAGE = "layout";
const PLAY_FROM_LABEL = "cw_home";
const NEWS = "news";
const MAGAZINE = "magazine";
const INITIAL_MODULE = 0;
const ButtonModalFocus = withFocusable(ModalButtonStyled);
const ListReferenced = props => <List {...props}>{props.children}</List>;
const ListFocus = withFocusable(ListReferenced);
const defaultFocusPath = "lists";
const onlineContent = "online";
//let signupInactivePromptTimer = null;

const bannerButtonFocusPath = "bannerButton_passThru";

let sdk = null;
let mediaSlider;
var timer = null;
// let listRef = null;
// FIXME: WBIGS-690 - Remove with new carousel
let rtlToFix = 0;
const width = window.innerWidth;
const height = window.innerHeight;
let amountOfDownloadedModules = {};
let amountOfTotalModules = {};
let isChampionsTrophyPage = false;

const isBrand = window.location.pathname.includes("brands");

function buildAmountOfDownloadedModulesObject() {
  Object.values(sections).forEach(section => {
    section !== "search" && (amountOfDownloadedModules[section] = 0);
  });
}
function buildAmountOfTotalModulesObject() {
  Object.values(sections).forEach(section => {
    section !== "search" && (amountOfTotalModules[section] = 0);
  });
}

function getErrorHandlingCallbacks(finalModule, isLayoutExpired = false) {
  const {
    stateActions: { hideGlobalModal },
    history: { goBack }
  } = this.props;
  const retry = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    this.getLayout({ initialModule: INITIAL_MODULE, finalModule: finalModule, refreshLayout: isLayoutExpired });
  };
  const back = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    goBack();
  };

  return { retry, back };
}

/**
 * Handles the error received from getLayout request.
 * @param {Error} error - Error thrown.
 * @param finalModule
 */
async function handleError(error, finalModule = this.getFinalModule()) {
  const {
    stateActions: { showGlobalModal },
    resumeNavigation,
    setFocus
  } = this.props;
  const isLayoutExpired = error.error_code === sdk.mediaManager.mediaErrorCodes.LAYOUT_EXPIRED;
  const { retry, back } = getErrorHandlingCallbacks.call(this, finalModule, isLayoutExpired);

  if (isLayoutExpired) {
    this.props.applicationState.userRelatedModules = null;
    this.props.applicationState.list5NewsModules = null;
    this.getLayout({ initialModule: INITIAL_MODULE, finalModule: finalModule, refreshLayout: isLayoutExpired });
  } else if (!this.state.modules || this.state.modules.modules.length === 0) {
    // Only show errors if there are no modules on screen, otherwise, ignore
    // TODO There are cases when the timeout error message appears like "Gateway Time-out". It should enter in the if
    // Example: When a call to a layout section returns a 503
    if (getAppState().isOnline && error && error.message.indexOf("timeout") > -1) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back,
          needsDismissableProp: false,
          isTimeout: true
        })
      );
    } else if (!getAppState().isOnline && !error.status && !error.response) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back
        })
      );
    } else {
      const buttons = [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: retry
        },
        {
          ...getGlobalButtonInfo("back"),
          buttonHandler: back
        }
      ];
      showGlobalModal({
        modalText: i18n.get("global.errors.genericError"),
        buttons
      });
    }
    resumeNavigation();
    setFocus(getGlobalButtonFocusPath("retry"));
  }
}

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wheelState: "idle",
      isLoading: false,
      modules: null,
      nameSection: getPath(props),
      hasRunSubLayoutFocus: false,
      hasRunSubLayoutFocus: false,
      modal4K: false,
      isExiting: false,
      scrollToIndex: -1,
      initialScroll: 0,
      didPlayerLaunch: false,
      isLastRowHeightCache: false,
      mediaControlMenu: getMediaItems(),
      hasHeroModule: false,
      isLoaded: true,
      modulesActualLength: 0,
      isActiveBrand: false,
      priceObj: null,
      tvImpressionWatchedList: []
    };

    const isBrand = window.location.pathname.includes("brands");
    this.sections = [];
    this.videoConfig = {};
    this.has4K = false;
    this.initialFocus = defaultFocusPath;
    this.play4KModalFocusPath = null;
    this.confirmModalFocusPath = null;
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
    this.playFromLabel = PLAY_FROM_LABEL;
    this.onChangeItem = this.onChangeItem.bind(this);
    this.close4KModal = this.close4KModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.appNeedToClose = this.appNeedToClose.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleMediaControlsEnter = this.handleMediaControlsEnter.bind(this);
    this.isRowFocused = this.isRowFocused.bind(this);
    this.isCropped = this.isCropped.bind(this);
    this._onModulesUp = this._onModulesUp.bind(this);
    this._onModulesDown = this._onModulesDown.bind(this);
    this._onModulesLeft = this._onModulesLeft.bind(this);
    this._onModulesRight = this._onModulesRight.bind(this);
    this.rowHeightCalculator = this.rowHeightCalculator.bind(this);
    this.dontShowEmptyActive = this.dontShowEmptyActive.bind(this);
    this.getListRowCount = this.getListRowCount.bind(this);
    this.updateCarouselStateIndexes = this.updateCarouselStateIndexes.bind(this);
    this.getInitialSlide = this.getInitialSlide.bind(this);
    this.getLayout = this.getLayout.bind(this);
    this.onBack = this.onBack.bind(this);
    this.goTop = this.goTop.bind(this);
    this.onEnterPlay = this.onEnterPlay.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.slideUpDown = this.slideUpDown.bind(this);
    //onclicks binds
    this.openFullCatalogLayout = this.openFullCatalogLayout.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
    this.rowHeightCalculator = this.rowHeightCalculator.bind(this);

    this.onRefCarousel = this.onRefCarousel.bind(this);
    this.onMediaControlsLeft = this.onMediaControlsLeft.bind(this);
    this.onMediaControlsRight = this.onMediaControlsRight.bind(this);
    this.showAnimations = config.get().ui.animations;
    this.throttleTime = config.get().ui.throttle;
    const backToTopConfig = config.get().featureToggles.backToTop;
    this.carouselToShowBack = backToTopConfig && backToTopConfig.carouselToShowBack;
    this.scrollPositions = [];
    this.onModulesUp = throttle(this._onModulesUp, this.throttleTime.medium);
    this.onModulesDown = throttle(this._onModulesDown, this.throttleTime.medium);
    this.onModulesLeft = throttle(this._onModulesLeft, this.throttleTime.medium);
    this.onModulesRight = throttle(this._onModulesRight, this.throttleTime.medium);
    this.isSports = window.location.pathname.includes("sports");
    this.onMediaControlsDown = this.onMediaControlsDown.bind(this);
    this.onMediaControlsUp = this.onMediaControlsUp.bind(this);
    this.handleMediaControlsActions = this.handleMediaControlsActions.bind(this);
    this.closeGlobalModal = this.closeGlobalModal.bind(this);
    this.getAvoidCacheModules = this.getAvoidCacheModules.bind(this);
    this.mergeModules = this.mergeModules.bind(this);
    this.signupInactivePromptTimer = null;
    this.brandName = getBrandName(isBrand);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.cache = new CellMeasurerCache({
      defaultHeight: height / 3,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        const data = this.state.modules?.modules[rowIndex];
        if (data) {
          return `${data?.id}`;
        } else {
          return `${rowIndex + columnIndex}`;
        }
      }
    });

    this.videoData = null;

    this.TypedCarouselStyledMemo = memo(
      props => {
        return <TypedCarouselStyled onClickPoster={i => this.onClickPoster(i)} {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className &&
          props.showArrows !== newProps.showArrows
        );
      }
    );
    Object.keys(amountOfDownloadedModules).length === 0 && buildAmountOfDownloadedModulesObject();
    Object.keys(amountOfTotalModules).length === 0 && buildAmountOfTotalModulesObject();

    this.promptRef = React.createRef();
    this.currentProfile = null;
    this.isList5NewsCategoryCalled = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // FIXME: Try to remove focus path for preventing the modification of scrollToIndex
    const {
      history,
      location,
      applicationState: { focusedSubLayoutCarouselId }
    } = nextProps;
    const focus4kModal = ["play4KModal_passThru", "playHDModal_passThru"];
    const isBrowserBack = history.action === "POP";
    if (
      !prevState.hasRunSubLayoutFocus &&
      isBrowserBack &&
      (isADMNRoute(location.referrer) || location.referrer.includes("category")) &&
      !(/^\/admn\/movies\/[^/]+$/.test(location.referrer) || /^\/admn\/series\/[^/]+$/.test(location.referrer)) &&
      focusedSubLayoutCarouselId &&
      focusedSubLayoutCarouselId.length !== 0
    ) {
      if (location.referrer.startsWith("/admn/") || location.referrer.startsWith("/category/")) {
        const moduleIndex = prevState.modules?.modules.findIndex(module => {
          return module.id === focusedSubLayoutCarouselId.slice(-1)[0];
        });
        return {
          scrollToIndex: moduleIndex || 0
        };
      }
    } else if (
      nextProps.applicationState.currentFocus !== defaultFocusPath &&
      !focus4kModal.includes(nextProps.applicationState.currentFocus)
    ) {
      if (prevState.isExiting) {
        return null;
      } else if (nextProps.applicationState.currentFocus === "buttonPlay") {
        return {
          scrollToIndex: nextProps.applicationState.focusedCarouselIndex || 0
        };
      } else {
        if (prevState.isWheel) {
          if (
            nextProps.currentFocus == "mainMenu" &&
            prevState.scrollToIndex == 0 &&
            prevState.scrollDirection == "up"
          ) {
            return {
              scrollToIndex: -1
            };
          } else {
            return {};
          }
        } else {
          return {
            scrollToIndex: -1
          };
        }
      }
    } else if (prevState.scrollToIndex === -1) {
      if (
        i18n.getDirection() === directions.RIGHT_TO_LEFT &&
        rtlToFix === 2 &&
        nextProps.applicationState.focusedCarouselIndex &&
        nextProps.applicationState.focusedCarouselItemIndex
      ) {
        rtlToFix = 1;
        nextProps.applicationState.focusedCarouselItemIndex -= 1;
      }

      return {
        scrollToIndex:
          prevState.isWheel && prevState.wheelState == "active"
            ? prevState.scrollToIndex
            : nextProps.currentFocus == defaultFocusPath
            ? nextProps.applicationState.focusedCarouselIndex
            : nextProps.applicationState.focusedCarouselIndex || 0,
        initialScroll: nextProps.applicationState.layoutScrollTop
      };
    } else {
      // If any other focus change occurs, mark that admn-focused behavior shouldn't run further
      if (!prevState.hasRunSubLayoutFocus && nextProps.applicationState.currentFocus !== undefined) {
        return { hasRunSubLayoutFocus: true };
      }
      return null;
    }
  }

  onClickPoster(itemIndex) {
    this.goTo(itemIndex);
  }
  onClickRow(i, rowIndex) {
    this.setState(() => ({ scrollToIndex: rowIndex }), this.updateCarouselStateIndexes);
    this.onClickPoster(i);
  }

  // FIXME: This function doesn't scale so well. What will happen when we have 15 possible popups and 10 different scenarios?
  onBack() {
    const {
      history: { location }
    } = this.props;
    if (this?.promptRef?.current) {
      if (getAppState().signupPromptActive) getAppState().signupPromptActive = false;
      if (this.signupInactivePromptTimer) {
        clearTimeout(this.signupInactivePromptTimer);
      }
    }
    const globalModal = getAppState().globalModal;
    if (globalModal && globalModal.dismissable && !getAppState().isOnline) {
      this.props.stateActions.hideGlobalModal();
      getSdk().systemManager.application.exit();
    } else if (this.state.modal4K) {
      // Close 4K prompt.
      this.close4KModal();
    } else if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
    } else if (this.state.didPlayerLaunch) {
      // Cancel player launch
      this.setState({ didPlayerLaunch: false });
      this.props.resumeNavigation();
    } else if (
      (!globalModal || globalModal.dismissable) &&
      this.isEnabled() &&
      this.props.applicationState.currentFocus === "mainMenu" &&
      config.get().featureToggles.exitAppPopup
    ) {
      // Show exit popup
      this.setState({ isExiting: true });
    } else if (globalModal && !globalModal.dismissable) {
      this.closeGlobalModal();
    } else if (this.state.scrollToIndex > this.carouselToShowBack) {
      // Going top if reached carouselToShowBack config
      this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      return true;
    } else if (
      location.pathname === "/movies" ||
      location.pathname === "/series" ||
      location.pathname === "/kids" ||
      location.pathname === "/arabic"
    ) {
      let to =
        getAppState().secLevelMenuPrevPath ||
        location?.referrer ||
        location?.state?.from?.name ||
        this?.props?.from ||
        "/";
      if (to.includes(location.pathname)) {
        to = this?.props?.from || "/";
      }
      this.props.history.replace(to);
    } else if (location.pathname.startsWith("/admn/") || location.pathname.startsWith("/category/")) {
      this.props.history.goBack();
      return true;
    } else if (location.pathname !== "/admn" && location.referrer === "/admn" && location.pathname.includes("brands")) {
      this.props.history.replace("/admn");
      return true;
    } else if (location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      this.props.history.replace("/brands");
    } else if (!location.pathname.includes("explore") && location.pathname.includes("brands")) {
      this.props.history.replace("/brands");
    } else if (!location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      this.setState({ scrollToIndex: 0 });
      this.props.setFocus(headerFocusPath);
      mediaSlider && mediaSlider.down();
      return true;
    }
    this.props.stateActions.setMediaControlItemFocus(-1);
    return true;
  }

  goTop() {
    if (this.state.scrollToIndex > this.carouselToShowBack) {
      // Going top if reached carouselToShowBack config
      this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
    }
  }

  isEnabled = () => !!this.state.modules && !this.state.didPlayerLaunch;

  closeGlobalModal = () => {
    const {
      location,
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    let savedFocusInfo = getSavedFocusInfo();
    if (savedFocusInfo) {
      let { name: from, currentFocus, index } = savedFocusInfo;
      removeSavedFocusInfo();
      const isHome =
        (from === "/home" && location.pathname === "/") ||
        (from === "/" && location.pathname === "/home") ||
        (from === "/" && location.pathname === "/")
          ? true
          : false;
      if (from === location.state?.from?.name || from === location.pathname || isHome) {
        if (currentFocus === "mediaControls" && index >= 0) {
          this.props.stateActions.setMediaControlItemFocus(index);
        }
        this.props.setFocus(currentFocus || defaultFocusPath);
        return;
      }
    }
    setFocus(defaultFocusPath);
    if (getAppState().signupPromptActive) getAppState().signupPromptActive = false;
  };

  closeSignUpModal = () => {
    const {
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    setFocus(bannerButtonFocusPath);
  };

  /**
   * New method to handle Hero action buttons functionalities. Play/Trailer/Info.
   *  */

  async handleMediaControlsActions() {
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, focusedMediaControlItemIndex },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    const module = this.state.modules.modules[0];
    const { type, id: moduleId } = module;
    const videoData = this.sections[0].handleAction();
    const { id, programType, progress, seriesId, addonContent } = videoData;
    const isThisDeviceSupported = userLogged ? await isSupportedDeviceForMobileLite.call(this, addonContent) : true;

    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId,
      profileType: getAppState()?.currentProfileType
    };

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const CurrentMediaControlList = this.state.mediaControlMenu;
    const selectedMediaControl =
      CurrentMediaControlList[focusedMediaControlItemIndex] &&
      CurrentMediaControlList[focusedMediaControlItemIndex]?.name;

    switch (selectedMediaControl) {
      case "play": // play button
        if (userLogged) {
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            showSubscriptionModal.call(this, addonContent, true);
            return;
          }
          if (!isUserSubscribedToChannel(addons, addonContent)) {
            showSubscriptionModal.call(this, addonContent, true);
            return;
          }

          if (!isThisDeviceSupported) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
          }

          if (!!getAppState().isOnline) {
            // Byte+ GA event for play click
            // sendVideoPlayClickEventDataForBytePlus({ thisInstance: this, carouselData: module, carouselOrderId: index, titleOrderId: this.sections[index].selectedIndex, mediaData: videoData, previousScreen: this?.props?.history?.location?.referrer || null })
            playHandler.call(this, undefined, {
              from: {
                name: this.props.location.pathname || this.props.from,
                currentFocus: this.props.currentFocus,
                index: focusedMediaControlItemIndex
              }
            });
          } else {
            const retry = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              this.getLayout();
            };

            const back = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              history.goBack();
            };
            showGlobalModal(
              getInternetConnectivityModalConfig.call(this, {
                retryImplementation: retry,
                backImplementation: back
              })
            );
            setFocus(getGlobalButtonFocusPath("retry"));
          }
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "trailer": // trailer
        const trailerData = {
          videoType: "trailer",
          contentTypeYoubora: "trailer",
          id: id,
          moduleId: moduleId,
          moduleType: type,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        };
        const pathname = routes.player;
        history["push"]({
          pathname,
          ...(trailerData && {
            state: trailerData
          })
        });

        break;

      default:
        // info button
        goToDetailPageByProgramType.call(this, {
          id,
          programType,
          moduleId,
          sectionName: this.state.nameSection,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        });
    }
  }

  async handleMediaControlsEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      applicationState: { currentFocus }
    } = this.props;

    if (this.state.scrollToIndex === -1 && currentFocus === mediaControlFocusPath) {
      this.handleMediaControlsActions();
      return;
    }
  }

  getDataToSentBuyAsset(videoData = null) {
    return {
      title: videoData.title,
      addonContent: videoData.addonContent,
      titleId: videoData.id,
      price: null
    };
  }

  async handleEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      setFocus,
      history,
      applicationState: {
        userAccountStatus,
        addons,
        userLogged,
        focusedMediaControlItemIndex,
        focusedCarouselItemIndex,
        remoteConfig: { news_direct_playback, magazine_direct_playback }
      },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const index = this.state.scrollToIndex;
    /**
     * below commented check was there for Explore button present in other layout pages except home (movies/tvshows/arabic etc) pages  below the first carousel
     * So there was some logic implemeneted earlier team for focus managment and position to place below firts carousel in grid layout row.
     *  As per the new UI revamp(Android theme) need to plae Explore button end of the page , so prevoius logics has to be scrapped.
     *  */

    /*const moduleIndex = this.state.nameSection !== "home" && this.state.scrollToIndex > 0 ? index - 1 : index;
     if (this.state.nameSection !== "home" && this.state.scrollToIndex === 1)
    */
    const moduleIndex = index;
    const isSpecialLayout = !!(
      this.state.nameSection === "home" ||
      isADMNRoute(history.location.pathname) ||
      history.location.pathname.includes("category")
    );
    if (!isSpecialLayout && this.state.scrollToIndex === amountOfDownloadedModules[this.state.nameSection]) {
      trackEvent("explore catalogue", this.state.nameSection, this.state.nameSection);
      // byte+
      sessionStorage.removeItem("refCarId");
      sessionStorage.removeItem("refCarouselName");
      sessionStorage.removeItem("refCarouselOrderId");
      return this.goFullCatalog();
    }
    const module = this.state.modules.modules[moduleIndex];
    const { type, category, id: moduleId, friendlyTitle, layoutOrder } = module;
    const videoData = this.sections[index].handleAction();
    const {
      id,
      programType,
      progress,
      seriesId,
      addonContent,
      license,
      products,
      subscription = [],
      subscriptionPerCountry,
      destination,
      contentType: videoContentType
    } = videoData;
    const isTVOD =
      (videoData.assetTypes &&
        videoData.assetTypes.length > 0 &&
        isTVODContent(videoData.assetTypes) &&
        isTVODPriority(videoData.assetTypesPriority)) ||
      false;

    const contentType = isTVOD
      ? "TVOD"
      : isAVOD(videoData)
      ? "AVOD"
      : isSVOD(videoData)
      ? "SVOD"
      : (license && pramsYouborra(isTVOD, license)) || "";

    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId, // FIXME this is not actually something related to video, it should not be here
      contentType,
      onlineContent,
      profileType: getAppState()?.currentProfileType
    };
    // track byte+ event
    if (module.category !== "ListBrandsActive" && module.category !== "ListBrandsDisabled") {
      sendCarouselClickEventDataForBytePlus({
        carouselData: module,
        mediaData: videoData,
        titleOrderId: this.sections[index].selectedIndex,
        carouselOrderId: index,
        currentScreen: sessionStorage?.getItem("currentScreen"),
        previousScreen: sessionStorage?.getItem("prevScreen")
      });
    } else {
      videoData.id = videoData.title;
      sendCarouselClickEventDataForBytePlus({
        carouselData: module,
        mediaData: videoData,
        titleOrderId: this.sections[index].selectedIndex,
        carouselOrderId: index,
        currentScreen: sessionStorage?.getItem("currentScreen"),
        previousScreen: sessionStorage?.getItem("prevScreen")
      });
    }
    trackEvent(
      "browsing|layout_modules",
      `${this.state.nameSection}|${category}`,
      await getLayoutEventLabel(category, layoutOrder, this.sections[index].selectedIndex, friendlyTitle)
    );

    switch (type) {
      case "LiveChannels": // Live carousel
        if (userLogged) {
          let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, addonContent, subscription);
          const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
            this,
            isUserSubscribedToAsset,
            addonContent,
            subscriptionPerCountry
          );
          videoData.addonContent = multiTaggedAddOnContent;
          isUserSubscribedToAsset = isUserSubscribedToChannel(addons, videoData.addonContent, subscription);
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(videoData.addonContent)) {
            showSubscriptionModal.call(this, addonContent, true);
            return;
          }
          if (!isUserSubscribedToAsset) {
            showSubscriptionModal.call(this, addonContent, true);
            return;
          }

          this.setState(
            {
              isLoaded: false
            },
            async () => {
              const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, videoData.addonContent);
              this.setState({ isLoaded: true });
              if (!isThisDeviceSupported) {
                return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
              }

              if (!!getAppState().isOnline) {
                // Byte+ GA event for play click
                sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
                sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
                sendVideoPlayClickEventDataForBytePlus({
                  currentScreen: sessionStorage.getItem("currentScreen"),
                  previousScreen: sessionStorage.getItem("prevScreen"),
                  thisInstance: this,
                  carouselData: module,
                  carouselOrderId: index,
                  titleOrderId: this.sections[index].selectedIndex,
                  mediaData: videoData
                });
                playHandler.call(this, {
                  from: {
                    name: this.props.location.pathname || this.props.from,
                    currentFocus: this.props.currentFocus,
                    index: focusedMediaControlItemIndex
                  }
                });
                this.props.stateActions.setCarouselItemFocus(0);
              } else {
                const retry = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  this.getLayout();
                };

                const back = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  history.goBack();
                };
                showGlobalModal(
                  getInternetConnectivityModalConfig.call(this, {
                    retryImplementation: retry,
                    backImplementation: back
                  })
                );
                setFocus(getGlobalButtonFocusPath("retry"));
              }
            }
          );
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "cw": // continue watching
        this.props.stateActions.setPosterLandscapeImage(
          (videoData && videoData.images && videoData.images.posterLandscape) || ""
        );
        videoData && videoData.license && setCurrentStatusForPlayerObj(videoData && videoData.license);
        const ageRestriction =
          this.currentProfile?.profileCategory === "KIDS" || Number(this.currentProfile?.parentalControl) <= 7;
        if (ageRestriction && videoData.ageRating >= 15) {
          return showContentNotAccessibleModal.call(this, this.closeGlobalModal, null);
        }
        if (videoData.freeToAir) {
          localStorage.setItem("isThisSeriesHasFreeEpisodes", true);
          this.setState(
            {
              isLoaded: false
            },
            async () => {
              const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, videoData.addonContent);
              this.setState({ isLoaded: true });
              if (!isThisDeviceSupported) {
                return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
              }

              if (getAppState().isOnline) {
                // Byte+ GA event for play click
                sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
                sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
                sendVideoPlayClickEventDataForBytePlus({
                  currentScreen: sessionStorage.getItem("currentScreen"),
                  previousScreen: sessionStorage.getItem("prevScreen"),
                  thisInstance: this,
                  carouselData: module,
                  carouselOrderId: index,
                  titleOrderId: this.sections[index].selectedIndex,
                  mediaData: videoData
                });
                playHandler.call(this, videoData);
                this.props.stateActions.setCarouselItemFocus(0);
                return;
              } else {
                const retry = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  this.getLayout();
                };

                const back = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  history.goBack();
                };
                showGlobalModal(
                  getInternetConnectivityModalConfig.call(this, {
                    retryImplementation: retry,
                    backImplementation: back
                  })
                );
                setFocus(getGlobalButtonFocusPath("retry"));
              }
            }
          );
        } else {
          let isSVOD = isSVODContent(videoData.assetTypes) || false;
          const isAssetActive = isSVOD ? isContentActive(addons, addonContent, subscription) : false;

          let isTVODFlow = false;
          if (isAvodAssets(videoData?.assetTypes)) {
            if (!!getAppState().isOnline) {
              // Byte+ GA event for play click
              sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
              sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
              sendVideoPlayClickEventDataForBytePlus({
                currentScreen: sessionStorage.getItem("currentScreen"),
                previousScreen: sessionStorage.getItem("prevScreen"),
                thisInstance: this,
                carouselData: module,
                carouselOrderId: index,
                titleOrderId: this.sections[index].selectedIndex,
                mediaData: videoData
              });
              playHandler.call(this);
              this.props.stateActions.setCarouselItemFocus(0);
              return;
            }
          }
          if (isTVOD && !isAssetActive) {
            const eventData = {
              pageType: videoData.programType,
              pathname: history.location.pathname,
              titleId: videoData.id,
              title: videoData.title,
              addonContent: videoData.addonContent,
              tagList: videoData.tagList,
              profileId: this.currentProfile?.profileId
            };
            if (license && (license.state.toLowerCase() === "init" || license.state.toLowerCase() === "active")) {
              isTVODFlow = true;
            } else if (license && expiredContent(license.state) && products) {
              return showExpiredContentModal.call(this, this.closeGlobalModal, videoData, eventData);
            } else {
              return showExpiredContentModal.call(this, this.closeGlobalModal, videoData, eventData);
            }
          }

          if (isSVOD && !isAssetActive && !isTVODFlow) {
            let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, addonContent, subscription);
            const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
              this,
              isUserSubscribedToAsset,
              addonContent,
              subscriptionPerCountry
            );
            videoData.addonContent = multiTaggedAddOnContent;
            isUserSubscribedToAsset = isUserSubscribedToChannel(addons, videoData.addonContent, subscription);
            if (!isUserAccountActive(userAccountStatus) && !isAddonContent(videoData.addonContent)) {
              showSubscriptionModal.call(this, addonContent, true);
              return;
            }

            if (!isUserSubscribedToAsset) {
              showSubscriptionModal.call(this, addonContent, true);
              return;
            }
          }

          this.setState(
            {
              isLoaded: false
            },
            async () => {
              const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, videoData.addonContent);
              this.setState({ isLoaded: true });
              if (!isThisDeviceSupported) {
                return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
              }

              if (getAppState().isOnline) {
                // Byte+ GA event for play click
                sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
                sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
                sendVideoPlayClickEventDataForBytePlus({
                  currentScreen: sessionStorage.getItem("currentScreen"),
                  previousScreen: sessionStorage.getItem("prevScreen"),
                  thisInstance: this,
                  carouselData: module,
                  carouselOrderId: index,
                  titleOrderId: this.sections[index].selectedIndex,
                  mediaData: videoData
                });
                playHandler.call(this, videoData);
                this.props.stateActions.setCarouselItemFocus(0);
              } else {
                const retry = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  this.getLayout();
                };

                const back = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  history.goBack();
                };
                showGlobalModal(
                  getInternetConnectivityModalConfig.call(this, {
                    retryImplementation: retry,
                    backImplementation: back
                  })
                );
                setFocus(getGlobalButtonFocusPath("retry"));
              }
            }
          );
        }

        break;
      case "channels":
        const itemToRedirect = module.titles[focusedCarouselItemIndex];
        this.props.stateActions.setCarouselFocus(0);
        history.push("/brands/" + itemToRedirect?.name);

        break;
      case "List5Category":
        let pathName = "";
        switch (destination?.type) {
          case "page":
            if (destination?.menu === "admn") {
              pathName = `/admn/${destination?.target}`;
            } else {
              pathName = `/category/${destination?.target}`;
            }
            break;
          case "addon":
            pathName = `/brands/${destination?.target}`;
            break;
          case "epg-category":
            pathName = `/live?category=${destination?.target}`;
            break;
          case "epg-channel":
            pathName = `/live?category=${destination?.category}`;
            break;
          default:
            return;
        }
        if (history.location.pathname !== pathName) {
          this.props.stateActions.setCarouselFocus(0);
          this.props.stateActions.setCarouselItemFocus(0);
          this.props.stateActions.setSubLayoutCarouselFocus(moduleId);
          this.props.stateActions.setSubLayoutCarouselItemFocus(focusedCarouselItemIndex);
          if (destination?.type === "page") {
            history.push({
              pathname: pathName,
              state: {
                title: videoData.title
              }
            });
          } else {
            history.push(pathName);
          }
        }

        break;
      default:
        const isNewsContent = !!(videoContentType?.toLowerCase() === NEWS && news_direct_playback);
        const isMagazineContent = !!(videoContentType?.toLowerCase() === MAGAZINE && magazine_direct_playback);
        if (isNewsContent || isMagazineContent) {
          sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
          sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
          sendVideoPlayClickEventDataForBytePlus({
            currentScreen: sessionStorage.getItem("currentScreen"),
            previousScreen: sessionStorage.getItem("prevScreen"),
            thisInstance: this,
            carouselData: module,
            carouselOrderId: index,
            titleOrderId: this.sections[index].selectedIndex,
            mediaData: videoData
          });
          playHandler.call(this, {
            from: {
              name: this.props.location.pathname || this.props.from,
              currentFocus: this.props.currentFocus,
              index: focusedMediaControlItemIndex
            }
          });
          this.props.stateActions.setCarouselItemFocus(0);
        } else {
          const isADMN = isADMNContent(videoData.contentOwnership) || false;
          this.props.stateActions.setPosterLandscapeImage(
            (videoData && videoData.images && videoData.images.posterLandscape) || ""
          );

          goToDetailPageByProgramType.call(this, {
            id,
            programType,
            moduleId,
            sectionName: getSectionName(isADMN, getPath(this.props))
          });
        }
    }
  }

  setFocusAfterModalOpen(focusPath) {
    const { setFocus } = this.props;
    setTimeout(() => {
      this.props.resumeNavigation();
    }, 1);
    setFocus(focusPath);
  }

  goFullCatalog() {
    sessionStorage.removeItem("refCarouselRecVariant"); // reset the value so that rec_variant value is correctly passed in explore page.
    const { history } = this.props;
    const fullCatalogPath = `${routes.explore}${history.location.pathname}`;
    history.push({
      pathname: fullCatalogPath,
      state: {
        sectionName: this.state.nameSection,
        from: {
          name: this.props.location.pathname || this.props.from,
          currentFocus: this.props.currentFocus,
          index: -1
        }
      }
    });
  }

  async onChangeItem(index) {
    const title = this.sections[this.state.scrollToIndex].handleAction();
    const { sponsorBug } = title;
    this.props.stateActions.setCarouselItemFocus(index);

    if (this.props.applicationState.focusedCarouselIndex === 0) {
      this.checkTrailerMediaButtonToShow(0, index);
    }
    if (sponsorBug) {
      await impressionTracking(sponsorBug?.impressionTrackingURL);
    }
  }

  close4KModal() {
    this.setState({ modal4K: false });
    this.props.setFocus(defaultFocusPath);
  }

  closeConfirmModal() {
    this.setState({ isExiting: false });
    this.props.setFocus(defaultFocusPath);
  }

  appNeedToClose() {
    getSdk().systemManager.application.exit();
    this.closeConfirmModal();
  }

  updateCarouselStateIndexes() {
    // Clear cached heights if not measured from start
    if (!this.cache.has(this.state.scrollToIndex) || Object.keys(this.cache._rowHeightCache).length < 3) {
      this.cache.clearAll();
    }
    this.props.stateActions.setCarouselFocus(this.state.scrollToIndex);
    this.props.stateActions.setCarouselItemFocus(0);
  }

  onEnterPlay(is4K = false) {
    // Reset continue watching carousel index
    this.props.stateActions.setCarouselItemFocus(0);
    this.setState({ didPlayerLaunch: true });
    this.props.pauseNavigation();
    play.bind(this, is4K)();
  }

  openFullCatalogLayout() {
    this.setState({ scrollToIndex: 1 }, this.updateCarouselStateIndexes);
    trackEvent("explore catalogue", this.state.nameSection, this.state.nameSection);
    this.goFullCatalog();
  }
  _onModulesUp(isButtons = false) {
    if (this.state.isWheel && this.state.scrollToIndex > 0) {
      this.props.setFocus(defaultFocusPath);
    }
    if (isButtons) {
      this.setState({ isWheel: false });
    }

    const {
      setFocus,
      stateActions: { setMediaControlItemFocus }
    } = this.props;
    if (!!this.state.modules && this.state.scrollToIndex > 0) {
      // track byte+ event. checking in tvImpressionWatchedList first ensures that trueview is called only once per carousel in a page load.
      let prevIndex = this.state.scrollToIndex - 1;
      if (!this.state.tvImpressionWatchedList.includes(prevIndex)) {
        if (
          this.state.modules.modules[prevIndex].category != "ListBrandsDisabled" &&
          this.state.modules.modules[prevIndex].category != "ListBrandsActive"
        ) {
          this.setState({ tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, prevIndex] });
          sendTrueViewImpressionForBytePlus({
            currentScreen: sessionStorage?.getItem("currentScreen") || null,
            previousScreen: sessionStorage.getItem("prevScreen"),
            carouselData: this.state.modules.modules[prevIndex],
            carouselOrderId: prevIndex
          });
        }
      }
      this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex - 1 }), this.updateCarouselStateIndexes);
    } else if (!!this.state.modules && !this.state.isActiveBrand && this.brandName) {
      this.brandName && this.props.setFocus(bannerButtonFocusPath);
      return;
    } else if (this.state.hasHeroModule) {
      if (this.state.isWheel) {
        // this.setState({ scrollToIndex: -1 }, () => {
        //   this.updateCarouselStateIndexes();
        //   this.props.setFocus(headerFocusPath);
        // });
        return;
      } else {
        //this.brandName !== "brands" && this.props.setFocus(headerFocusPath);
        /* Decided to hide Media control from hero. so whe user navigateup from hero carousel we need block that event instead of going to media control below
       - two line commented for this reason and return */
        //this.brandName !== "brands" && setFocus('mediaControls');
        //setMediaControlItemFocus();
        return;
      }
    }
  }

  _onModulesDown(isButtons = false) {
    const { history } = this.props;
    if (this.state.isWheel && this.state.scrollToIndex > -1) {
      this.props.setFocus(defaultFocusPath);
    }
    if (isButtons) {
      this.setState({ isWheel: false });
    }
    const modulesPageSize = config.get().layouts.modulesPageSize;
    const isSpecialLayout = !!(
      this.state.nameSection === "home" ||
      isADMNRoute(history.location.pathname) ||
      history.location.pathname.includes("category")
    );
    if (
      !!this.state.modules &&
      this.state.scrollToIndex < amountOfDownloadedModules[this.state.nameSection] - (!isSpecialLayout ? 0 : 1)
    ) {
      // track byte+ event
      let newIndex = this.state.scrollToIndex + 1;
      if (!this.state.tvImpressionWatchedList.includes(newIndex)) {
        if (this.state.modules.modules[newIndex]) {
          if (
            this.state.modules.modules[newIndex].category != "ListBrandsDisabled" &&
            this.state.modules.modules[newIndex].category != "ListBrandsActive"
          ) {
            this.setState({ tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, newIndex] });
            sendTrueViewImpressionForBytePlus({
              currentScreen: sessionStorage?.getItem("currentScreen") || null,
              previousScreen: sessionStorage.getItem("prevScreen"),
              carouselData: this.state.modules.modules[newIndex],
              carouselOrderId: newIndex
            });
          }
        }
      }
      this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex + 1 }), this.updateCarouselStateIndexes);

      if (
        amountOfDownloadedModules[this.state.nameSection] - this.state.scrollToIndex <= modulesPageSize &&
        amountOfDownloadedModules[this.state.nameSection] < this.state.modules.modules.length
      ) {
        this.getLayout({
          initialModule: amountOfDownloadedModules[this.state.nameSection],
          finalModule: amountOfDownloadedModules[this.state.nameSection] + modulesPageSize
        });
      }
      // track byte+ event
      // if(this.state.modules.modules[this.state.scrollToIndex]){
      // sendTrueViewImpressionForBytePlus({currentScreen:sessionStorage?.getItem("currentScreen") || null, previousScreen: sessionStorage.getItem("prevScreen"), carouselData: this.state.modules.modules[this.state.scrollToIndex], carouselOrderId: this.state.scrollToIndex})
      // }
    }
  }

  _onModulesLeft() {
    if (!!this.state.modules) {
      this.left(this.state.scrollToIndex);
    }
    this.setState({ isWheel: false, wheelState: "idle" });
  }

  _onModulesRight() {
    if (!!this.state.modules) {
      this.right(this.state.scrollToIndex);
    }
    this.setState({ isWheel: false, wheelState: "idle" });
  }
  onMediaControlsLeft() {
    const isHeaderShown = !noHeader(window.location.pathname);
    if (mediaSlider.state.mediaFocusedIndex > 0) {
      mediaSlider.left();
    } else if (isHeaderShown) {
      this.props.setFocus(headerFocusPath);
      mediaSlider && mediaSlider.down();
    }
  }

  onMediaControlsRight() {
    if (mediaSlider.state.mediaFocusedIndex < mediaSlider.state.mediaItemCount) {
      mediaSlider.right();
    }
  }

  onMediaControlsDown() {
    this.props.setFocus(defaultFocusPath);
    this.props.stateActions.setMediaControlItemFocus(-1);
    mediaSlider && mediaSlider.down();
  }
  onMediaControlsUp() {
    return;
  }

  getInitialSlide(index) {
    const {
      applicationState: { focusedCarouselIndex, focusedCarouselItemIndex, subLayoutCarouselItemIndex },
      history,
      location
    } = this.props;
    // const isSpecialLayout = !!(this.state.nameSection === "home" || isADMNRoute(location.pathname));
    const fixedIndex = index === 0 ? index : index + 1;
    const isBrowserBack = history.action === "POP";
    if (
      this.state.modules?.modules[index]?.type?.toLowerCase() === "hero" &&
      focusedCarouselItemIndex > this.state.modules?.modules[0]?.titles?.length - 1
    ) {
      return 0;
    } else if (
      isBrowserBack &&
      (isADMNRoute(location.referrer) || location.referrer.includes("category")) &&
      !(/^\/admn\/movies\/[^/]+$/.test(location.referrer) || /^\/admn\/series\/[^/]+$/.test(location.referrer)) &&
      subLayoutCarouselItemIndex &&
      subLayoutCarouselItemIndex.length
    ) {
      if (location.referrer.startsWith("/admn/") || location.referrer.startsWith("/category/")) {
        return this.state.modules.modules[index].category !== CAROUSEL_TYPES.watchlist &&
          fixedIndex === this.state.scrollToIndex
          ? subLayoutCarouselItemIndex.slice(-1)[0] || 0
          : 0;
      }
    } else {
      return this.state.modules.modules[index].category !== CAROUSEL_TYPES.watchlist &&
        fixedIndex === focusedCarouselIndex
        ? focusedCarouselItemIndex
        : 0;
    }
  }

  onRefCarousel(ref) {
    ref && (this.sections[ref.props.carouselIndex] = ref);
  }

  isRowFocused(index) {
    return this.state.scrollToIndex === index;
  }

  isCropped(index) {
    return (
      (index < this.state.scrollToIndex && this.state.scrollToIndex !== this.getListRowCount() - 1) ||
      index > this.state.scrollToIndex
    );
  }

  scrollUpDown(event) {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      this.setState({ wheelState: "idle" }, () => {
        clearTimeout(timer);
      });
    }, 1000);
    if (event.deltaY > 0) {
      // down wheel moves
      this.setState({ wheelState: "active", scrollDirection: "down" });
      this.onModulesDown();
    } else if (event.deltaY < 0) {
      this.setState({ wheelState: "active", scrollDirection: "up" });
      // up wheel moves
      if (this.props.location.pathname.includes("brands")) {
        if (this.state.scrollToIndex !== 0) {
          this.onModulesUp();
        }
      } else {
        this.onModulesUp();
      }
    }
  }

  slideUpDown(direction) {
    if (direction === "up") {
      this.onModulesUp();
    } else if (direction === "down") {
      this.onModulesDown();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.state.nameSection = getPath(this.props);
    const { isExiting, hasRunSubLayoutFocus } = this.state;
    const {
      history,
      location,
      applicationState: { focusedSubLayoutCarouselId },
      stateActions
    } = this.props;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();
    const isBrowserBack = history.action === "POP";
    if (
      !hasRunSubLayoutFocus &&
      isBrowserBack &&
      (isADMNRoute(location.referrer) || location.referrer.includes("category")) &&
      !(/^\/admn\/movies\/[^/]+$/.test(location.referrer) || /^\/admn\/series\/[^/]+$/.test(location.referrer)) &&
      focusedSubLayoutCarouselId &&
      focusedSubLayoutCarouselId.length
    ) {
      if (location.referrer.startsWith("/admn/") || location.referrer.startsWith("/category/")) {
        stateActions.popSubLayoutCarouselFocus();
        this.setState({ hasRunSubLayoutFocus: true });
      }
    }

    // FIXME: WBIGS-690 - Remove with new carousel
    if (
      i18n.getDirection() === directions.RIGHT_TO_LEFT &&
      rtlToFix === 1 &&
      this.sections[this.props.applicationState.focusedCarouselIndex]
    ) {
      rtlToFix = 0;
      this.sections[this.props.applicationState.focusedCarouselIndex] &&
        (!this.props.applicationState.userLogged || this.props.applicationState.focusedCarouselIndex !== 1) &&
        this.sections[this.props.applicationState.focusedCarouselIndex].left();
    }
    this.checkLiveCarouselEndOfTheModules();
    this.toggleMediaControls();
  }

  checkTrailerMediaButtonToShow(focusedCarouselIndex = 0, focusedCarouselItemIndex = 0) {
    if (this.state.modules) {
      let mediaMenu = null;

      if (focusedCarouselIndex === 0) {
        const module = this.state.modules.modules[0];
        const title = module && module.titles[focusedCarouselItemIndex];
        if (!title?.trailerMedia) {
          mediaMenu = this.state.mediaControlMenu.filter(item => item.name !== "trailer");
        } else {
          mediaMenu = getMediaItems();
        }
        this.setState({ mediaControlMenu: mediaMenu });
      }
    }
  }

  toggleMediaControls() {
    return this.props.currentFocus !== "mainMenu" && this.state.scrollToIndex <= 0
      ? mediaSlider?.show()
      : mediaSlider?.hide();
  }

  checkLiveCarouselEndOfTheModules = () => {
    if (this.state.modules) {
      this.state.modules.modules.map((module, index) => {
        if (this.state.modulesActualLength === index + 1 && module?.category === "ListLiveChannels") {
          if (!this.state.isLastRowHeightCache) {
            this.setState({ isLastRowHeightCache: true });
          }
        }
      });
    }
  };
  clearRowHeightCache = () => {
    if (this.state.modules) {
      const modulesLength = this.state.modules ? this.state.modulesActualLength : 0;
      const moduleLastIndex =
        this.state.nameSection !== "home" && modulesLength > 1 ? modulesLength - 1 : modulesLength;
      if (
        this.state.nameSection !== "home" &&
        this.state.modules.modules[moduleLastIndex]?.category === "ListLiveChannels"
      ) {
        this.cache.clearAll();
      }
    }
  };
  shouldComponentUpdate(nextProps, nextState) {
    this.isMagicRemoteActive = nextState.isWheel
      ? true
      : getSdk().systemManager.application.checkMagicRemote()
      ? true
      : false;
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.modules !== this.state.modules ||
      nextState.wheelState !== this.state.wheelState ||
      nextState.scrollToIndex !== this.state.scrollToIndex ||
      (this.state.modules &&
        nextState.modules.modules.filter(module => !!module.titles).length !==
          amountOfDownloadedModules[this.state.nameSection]) ||
      nextState.modal4K !== this.state.modal4K ||
      nextState.isExiting !== this.state.isExiting ||
      nextState.didPlayerLaunch !== this.state.didPlayerLaunch ||
      nextState.mediaControlMenu !== this.state.mediaControlMenu ||
      nextState.isLoaded !== this.state.isLoaded
    );
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
    rtlToFix = 2;
    if (this.signupInactivePromptTimer) {
      clearTimeout(this.signupInactivePromptTimer);
    }

    sdk.systemManager.application.off("visibilitychange", this.onVisibilityChange);
  }

  async componentDidMount() {
    isChampionsTrophyPage = isChampionsTrophyFlow()
      ? window?.location?.pathname?.includes(CHAMPIONS_TROPHY) || window?.location?.pathname?.includes(CRICLIFE)
      : false;
    this.setState({ hasHeroModule: false });
    if (["/", "/home", "/admn"].some(a => a === window?.location?.pathname)) {
      // **** tracking event in only home page ****
      trackEventInitializeData({
        page: "view_landingscreen",
        language: getLocaleFromLocalCache() || "en",
        referring_url: this.props.from
      });
      trackEventPushData({ event: "view_landingscreen" });
    }
    trackPage.call(this, PAGE);
    this.props.onRef(this);
    this.props.resumeNavigation();
    const { history, location } = this.props;
    const subscription = findFromBrands(this.state.nameSection, this.props.applicationState.subscriptions || []);
    const baseSubscription = findFromBrands(this.state.nameSection, subscription?.brands);
    this.setState({
      displayName: baseSubscription?.displayName || subscription?.displayName
    });

    this.setPriceObjForBrands.call(this);
    this.currentProfile = await getCurrentProfile();
    this.deviceBuilt = await getSdk().systemManager.device.getYear();

    // TODO: I'm not 100% sure, but I would bet removing this await would make the component behave identically

    await this.getLayout();
    this.checkTrailerMediaButtonToShow(0, this.props.applicationState.focusedCarouselItemIndex);
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();

    if (this.brandName === "brands") {
      history.location.referrer !== "/brands" && this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      this.props.setFocus("lists");
    }
    const prevFocusInfo = location.state?.from || getSavedFocusInfo();
    if (location.pathname === prevFocusInfo?.name) {
      let { currentFocus, index } = prevFocusInfo;
      if (currentFocus === "mediaControls" && index >= 0) {
        this.props.stateActions.setMediaControlItemFocus(index);
      }
      this.props.setFocus(currentFocus || "lists");
      // byte+ trigger trueview_impression for 1st visible carousel
      if (this.state && this.state?.modules) {
        if (this.state.modules?.modules.length > 0) {
          if (this.state.modules.modules[this.state.scrollToIndex]) {
            if (
              this.state.modules.modules[this.state.scrollToIndex]?.category != "ListBrandsDisabled" &&
              this.state.modules.modules[this.state.scrollToIndex]?.category != "ListBrandsActive"
            ) {
              this.setState({
                tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, this.state.scrollToIndex]
              });
              sendTrueViewImpressionForBytePlus({
                currentScreen: sessionStorage?.getItem("currentScreen") || null,
                previousScreen: sessionStorage?.getItem("prevScreen"),
                carouselData: this.state.modules.modules[this.state.scrollToIndex],
                carouselOrderId: this.state.scrollToIndex
              });
            }
          }
        }
      }
      return;
    }
    this.props.setFocus("lists");
    // byte+ trigger trueview_impression for 1st visible carousel
    if (this.state && this.state?.modules) {
      if (this.state.modules?.modules.length > 0) {
        if (
          this.state.modules.modules[this.state.scrollToIndex]?.category != "ListBrandsDisabled" &&
          this.state.modules.modules[this.state.scrollToIndex]?.category != "ListBrandsActive"
        ) {
          this.setState({ tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, this.state.scrollToIndex] });
          sendTrueViewImpressionForBytePlus({
            currentScreen: sessionStorage?.getItem("currentScreen") || null,
            previousScreen: sessionStorage?.getItem("prevScreen"),
            carouselData: this.state.modules.modules[this.state.scrollToIndex],
            carouselOrderId: this.state.scrollToIndex
          });
        }
      }
    }
    const userAccountStatus = await this.getUserAccountStatus();
    const userAddonStatus = await this.getUserAddonStatus();
    const isHidePromptForkids = await isHidePromptForKidsProfile();
    if (
      getAppState()?.signupPromptActive &&
      !isUserAccountActive(userAccountStatus) &&
      !userAddonStatus &&
      window?.location?.pathname !== "/live" &&
      !isHidePromptForkids
    ) {
      this.startSignupInactivePromptTimer();
    }
    sdk = await getSdk();
    // ON event listener network connection (systemManager)
    sdk.systemManager.application.on("visibilitychange", this.onVisibilityChange);
  }

  getUserAccountStatus = async () => {
    return getAppState()?.userAccountStatus;
  };

  getUserAddonStatus = async () => {
    return getAppState()?.userAddonStatus;
  };

  startSignupInactivePromptTimer = () => {
    if (this.signupInactivePromptTimer !== null) clearTimeout(this.signupInactivePromptTimer);
    this.signupInactivePromptTimer = setTimeout(() => {
      const hasAnyModalOpened = getAppState()?.globalModal;
      if (!hasAnyModalOpened || (hasAnyModalOpened && Object.keys(hasAnyModalOpened).length == 0)) {
        showSignupPremiumPrompt.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
      }
    }, getAppState().signupPromptTimer || 5000);
  };
  setPriceObjForBrands() {
    const { addons = [] } = getAppState();
    const isBrand = window.location.pathname.includes("brands");
    if (isBrand) {
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let isActiveBrand = addons?.find(
        addon =>
          (addon.name === subscription?.name || addon.name === this.brandName) &&
          addon?.status?.toLowerCase() === "active"
      );
      if (getAppState().userAccountStatus?.toLowerCase() === "active" && !isActiveBrand) {
        const base = getAppState().subscriptions?.filter(data => data?.name === starzplay);
        const baseBrands = base && [...base[0]?.brands];
        isActiveBrand = baseBrands?.find(addon => addon.name === subscription?.name || addon.name === this.brandName);
      }

      const priceObj = !isActiveBrand
        ? isChampionsTrophyPage
          ? getBuyBrandsInfoObjChampionsTrophy(addons, this.brandName)
          : getBuyBrandsInfoObj(addons, this.brandName)
        : null;
      this.setState({
        isActiveBrand: isActiveBrand || false,
        priceObj: priceObj
      });
    }
  }

  getUserRelatedModulesIndexes(modules, nameOfSection) {
    let {
      applicationState: { userRelatedModules }
    } = this.props;
    if (
      (!userRelatedModules && modules) ||
      (userRelatedModules && !userRelatedModules[`${nameOfSection}`] && modules)
    ) {
      const userModulesIndexes = [];
      for (let i = 0; i < modules.modules.length; i++) {
        modules.modules[i].isDynamic === true && userModulesIndexes.push(i);
      }
      if (userModulesIndexes.length > 0) {
        if (!userRelatedModules) this.props.applicationState.userRelatedModules = {};
        const finalUserRelatedModules = Object.assign(this.props.applicationState.userRelatedModules, {
          [`${nameOfSection}`]: userModulesIndexes
        });
        localStorage.setItem("userRelatedModules", JSON.stringify(finalUserRelatedModules));
        return finalUserRelatedModules;
      }
    }
    return userRelatedModules;
  }
  getList5NewsModulesIndexes(modules, nameOfSection) {
    let {
      applicationState: { list5NewsModules }
    } = this.props;
    if ((!list5NewsModules && modules) || (list5NewsModules && !list5NewsModules[`${nameOfSection}`] && modules)) {
      const list5NewsModulesIndexes = [];
      for (let i = 0; i < modules.modules.length; i++) {
        modules.modules[i].category === "List5News" && list5NewsModulesIndexes.push(i);
      }
      if (list5NewsModulesIndexes.length > 0) {
        if (!list5NewsModules) this.props.applicationState.list5NewsModules = {};
        const finalList5NewsModules = Object.assign(this.props.applicationState.list5NewsModules, {
          [`${nameOfSection}`]: list5NewsModulesIndexes
        });
        localStorage.setItem("list5NewsModules", JSON.stringify(finalList5NewsModules));
        return finalList5NewsModules;
      }
    }
    return list5NewsModules;
  }

  getFinalModule() {
    const { nameSection } = this.state;

    return amountOfDownloadedModules[nameSection] > 0
      ? amountOfDownloadedModules[nameSection] - 1
      : config.get().layouts.modulesPageSize;
  }
  getTotalModulesCountPerSection() {
    const { nameSection } = this.state;

    return amountOfTotalModules[nameSection] > 0
      ? amountOfTotalModules[nameSection] - 1
      : config.get().layouts.modulesPageSize;
  }
  /**
   * New logic has implemented always show latest data for avoided cahced modules.
   * This will take Avoided Cached Modules from Local storage if reload ,otherwise take it from App state
   */

  async getCacheAvoidedModulesFromLStore() {
    const userRelatedModulesFromStore = JSON.parse(localStorage.getItem("userRelatedModules")) || null;
    if (
      !this.props.applicationState.userRelatedModules &&
      this.state.nameSection === "home" &&
      userRelatedModulesFromStore &&
      userRelatedModulesFromStore[`${this.state.nameSection}`]
    ) {
      if (!this.props.applicationState.userRelatedModules) this.props.applicationState.userRelatedModules = {};
      await Object.assign(
        this.props.applicationState.userRelatedModules,
        userRelatedModulesFromStore[`${this.state.nameSection}`]
      );
    }
  }
  async getList5NewsCacheAvoidedModulesFromLStore() {
    const list5NewsModulesFromStore = JSON.parse(localStorage.getItem("list5NewsModules")) || null;
    if (
      !this.props.applicationState.list5NewsModules &&
      this.state.nameSection === "home" &&
      list5NewsModulesFromStore &&
      list5NewsModulesFromStore[`${this.state.nameSection}`]
    ) {
      if (!this.props.applicationState.list5NewsModules) this.props.applicationState.list5NewsModules = {};
      await Object.assign(
        this.props.applicationState.list5NewsModules,
        list5NewsModulesFromStore[`${this.state.nameSection}`]
      );
    }
  }

  getAvoidCacheModules(onlyNews = false) {
    const {
      applicationState: { userRelatedModules, list5NewsModules }
    } = this.props;

    const currentSection = this.state.nameSection;

    const newsModules = list5NewsModules && list5NewsModules[currentSection] ? list5NewsModules[currentSection] : [];

    const userModules =
      userRelatedModules && userRelatedModules[currentSection] ? userRelatedModules[currentSection] : [];

    if (onlyNews) {
      return newsModules.length ? { avoidCacheFor: newsModules } : null;
    } else {
      return userModules.length ? { avoidCacheFor: userModules } : null;
    }
  }

  mergeModules(modules, modulesExceptList5News) {
    let result = [];
    let ids = {};

    // Add the first array
    for (let i = 0; i < modules.length; i++) {
      const item = modules[i];
      result.push(item);
      ids[item.id] = i; // keep track of index by id
    }

    // Add or override from the second array
    for (let j = 0; j < modulesExceptList5News.length; j++) {
      const newItem = modulesExceptList5News[j];
      if (ids.hasOwnProperty(newItem.id)) {
        // override existing
        result[ids[newItem.id]] = newItem;
      } else {
        // add new one
        result.push(newItem);
      }
    }

    return result;
  }

  async getLayout({
    initialModule = INITIAL_MODULE,
    finalModule = this.getFinalModule(),
    refreshLayout = false,
    onlyNewsCarouselsFetch = false
  } = {}) {
    await this.getCacheAvoidedModulesFromLStore();
    await this.getList5NewsCacheAvoidedModulesFromLStore();
    const {
      applicationState: { userRelatedModules, list5NewsModules, country },
      stateActions: { showGlobalModal }
    } = this.props;
    sdk = await getSdk();
    if (userRelatedModules === null && list5NewsModules === null) {
      finalModule = config.get().layouts.modulesPageSize;
    }
    const finalModuleValue = onlyNewsCarouselsFetch ? this.getTotalModulesCountPerSection() : finalModule;

    const bytePlusPredictLayoutParams = await getParamsForPredictCall();
    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      if (!sameLayoutRequestIsInProgress(initialModule, finalModule)) {
        try {
          let modules = { modules: [], total: 0 };
          setLayoutRequestInProgress(initialModule, finalModule);
          const currentProfileType = getAppState()?.currentProfileType;
          const modulesExceptList5News = await sdk.mediaManager.getLayout(
            this.state.nameSection,
            {
              initialModule,
              finalModule: finalModuleValue,
              ...this.getAvoidCacheModules.call(this, onlyNewsCarouselsFetch),
              ...(refreshLayout === true && { refreshLayout }),
              profileType: currentProfileType,
              bytePlusPredictParams: bytePlusPredictLayoutParams,
              version: 2, // parameter send to web sdk for landscape images
              isList5NewsCategory: onlyNewsCarouselsFetch,
              country
            } || []
          );
          if (!this.isList5NewsCategoryCalled) {
            const newsModulesIndexes = JSON.parse(localStorage.getItem("list5NewsModules")) || {};
            const currentSectionNewsModules = newsModulesIndexes[this.state.nameSection] || [];
            const isNewsCarouselsFetch = currentSectionNewsModules.length > 0;
            const newsModulesFinalModule = isNewsCarouselsFetch ? this.getTotalModulesCountPerSection() : finalModule;

            if (isNewsCarouselsFetch) {
              const list5NewsModules = await sdk.mediaManager.getLayout(
                this.state.nameSection,
                {
                  initialModule,
                  finalModule: newsModulesFinalModule,
                  ...this.getAvoidCacheModules.call(this, isNewsCarouselsFetch),
                  ...(refreshLayout === true && { refreshLayout }),
                  profileType: currentProfileType,
                  bytePlusPredictParams: bytePlusPredictLayoutParams,
                  version: 2, // parameter send to web sdk for landscape images
                  isList5NewsCategory: isNewsCarouselsFetch,
                  country
                } || []
              );
              modules.modules = [...list5NewsModules.modules];
              this.isList5NewsCategoryCalled = true;
            }
          }
          modules.modules = this.mergeModules(modules.modules, modulesExceptList5News.modules);
          modules.total = modulesExceptList5News.total;

          this.props.applicationState.list5NewsModules = this.getList5NewsModulesIndexes(
            modules,
            this.state.nameSection
          );
          this.props.applicationState.userRelatedModules = this.getUserRelatedModulesIndexes(
            modules,
            this.state.nameSection
          );
          const self = this;
          let filteredArray =
            modules &&
            modules.modules &&
            modules.modules.reduce(function(filtered, module) {
              switch (module.category) {
                case "ListBrandsDisabled":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false) module.titles = [...getBrands("IN_ACTIVE", module.category)];
                    else module.titles = [...getSportsAddons("IN_ACTIVE", module.category)];
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListBrandsActive":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false) module.titles = [...getBrands("ACTIVE", module.category)];
                    else module.titles = [...getSportsAddons("ACTIVE", module.category)];
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListLiveChannels":
                  module.type = "LiveChannels";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Items":
                  module.type = "List5Items";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Org":
                  module.type = "List5Org";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5TopT":
                  module.type = "List5TopT";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5TopW":
                  module.type = "List5TopW";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Category":
                  module.type = "List5Category";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5News":
                  module.type = "List5News";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                default:
                  filtered.push(module);
              }

              return filtered;
            }, []);

          modules.modules = [...filteredArray];
          // let moduleToPass = modules.length > 0 && modules.modules.find(
          //   module => module.category === "List5CW" || module.type === "cw" || module.category === "ListRentedItems"
          // );
          let moduleToPass = modules.modules.length > 0 && modules.modules.filter(module => module.category !== "Hero");
          if (moduleToPass) {
            moduleToPass = tvodTimeExpire(moduleToPass);
          }
          unsetLayoutRequestInProgress();
          amountOfDownloadedModules[this.state.nameSection] =
            Array.isArray(modules.modules) &&
            modules.modules.length > 0 &&
            modules.modules.filter(module => !!module.titles)?.length;
          amountOfTotalModules[this.state.nameSection] = modules.total || 0;
          const module = modules?.modules[0];
          this.setState({
            hasHeroModule: module?.type?.toLowerCase() === "hero"
          });
          if (module && this.deviceBuilt >= YEAR_CONST) {
            module.titles =
              module.titles &&
              module.titles.length > 0 &&
              module.titles.map((title = {}) => {
                const { images } = title;
                if (images && images.heroMainFullscreen?.indexOf("data:") === -1) {
                  getCacheGeneratedImage(images && images.heroMainFullscreen, url => {
                    images.heroMainFullscreen = url;
                  });
                }
                if (images && images.posterLandscape?.indexOf("data:") === -1) {
                  getCacheGeneratedImage(images && images.posterLandscape, url => {
                    images.posterLandscape = url;
                  });
                }
                return title;
              });
          }
          // Ad-tech Project - getting sponsor bugs - Start
          if (this.props.applicationState.showSponsorBugs && this.state.hasHeroModule && module) {
            module.titles = await Promise.all(
              module.titles.map(async (title = {}) => {
                try {
                  const data = await getSponsorBug(title);
                  if (data) {
                    return { ...title, sponsorBug: { ...data } };
                  } else {
                    return { ...title, sponsorBug: null };
                  }
                } catch (error) {
                  console.error("API call failed:", error);
                  throw error;
                }
              })
            );
          }
          // Adtech Project - getting sponsor bugs - End

          const filteredSlicedModules = modules?.modules
            ?.slice(0, finalModule + 1)
            .filter(module => (module.titles && module.titles.length > 0) || module.items > 0);

          modules.modules = [...filteredSlicedModules, ...modules.modules?.slice(finalModule + 1)];
          this.setState({
            modules,
            modulesActualLength: modules?.modules?.length
          });
        } catch (error) {
          if (this.state.nameSection === "home") {
            if (error instanceof Error) {
              Sentry.captureException(error);
            }
          }
          unsetLayoutRequestInProgress();
          handleError.call(this, error, finalModule);
        }
      }
    } else {
      if (this.state.modules && this.state.modules.modules?.length) {
        const { retry, back } = getErrorHandlingCallbacks.call(this);
        showGlobalModal(
          getInternetConnectivityModalConfig.call(this, {
            retryImplementation: retry,
            backImplementation: back,
            needsDismissableProp: false,
            isTimeout: true
          })
        );
      }
    }
  }

  left(moduleIndex) {
    const module = this.sections[moduleIndex];
    if (!module) return;
    const { selectedIndex } = module;
    if (i18n.getDirection() !== directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      var pathName = window.location.pathname;
      if (
        pathName === "/movies" ||
        pathName === "/series" ||
        pathName === "/kids" ||
        pathName === "/arabic" ||
        (pathName.startsWith("/admn/") && pathName !== "/admn") ||
        (pathName.startsWith("/category/") && pathName !== "/category")
      ) {
        return;
      } else {
        const isHeaderShown = !noHeader(window.location.pathname);
        if (!isHeaderShown) return;
        this.props.setFocus(headerFocusPath);
        return;
      }
    }
    module.left();
  }

  goTo(itemIndex) {
    setTimeout(() => {
      this.sections[this.state.scrollToIndex] && this.sections[this.state.scrollToIndex].goTo(itemIndex);
      this.handleEnter();
    }, 50);
  }

  dontShowEmptyActive() {
    return !getAppState().userLogged;
  }
  right(moduleIndex) {
    const module = this.sections[moduleIndex];
    if (!module) return;
    const { selectedIndex } = module;
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      var pathName = window.location.pathname;
      var isBrand = window.location.pathname.indexOf("brands/");
      if (
        pathName === "/movies" ||
        pathName === "/series" ||
        pathName === "/kids" ||
        pathName === "/arabic" ||
        (pathName.startsWith("/admn/") && pathName !== "/admn") ||
        (pathName.startsWith("/category/") && pathName !== "/category") ||
        isBrand > -1
      ) {
        return;
      } else {
        this.props.setFocus(headerFocusPath);
        return;
      }
    }
    module.right();
  }

  getListRowCount() {
    const { history } = this.props;
    const isSpecialLayout = !!(
      this.state.nameSection === "home" ||
      isADMNRoute(history.location.pathname) ||
      history.location.pathname.includes("category")
    );
    return amountOfDownloadedModules[this.state.nameSection] + (!isSpecialLayout ? 1 : 0);
  }

  getBrandUrl() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return "";
    const brandName = getBrandName(true);
    return getBrandLogoUrl(brandName, this.props.applicationState.subscriptions);
  }

  isStarzSubscription() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return true;
    const brandName = getBrandName(true);
    return isStarzPlaySubscription(brandName, this.props.applicationState.subscriptions);
  }
  rowRenderer({ key, index, parent, style }) {
    const heroLayout = () => (
      <this.TypedCarouselStyledMemo
        onClickPoster={i => this.onClickRow(i, 0)}
        type="hero"
        items={getTitlesFormattedForCarousels.call(this, "hero", this.state.modules.modules[0].titles)}
        carouselIndex={0}
        onRef={this.onRefCarousel}
        initialSlide={this.getInitialSlide(0)}
        onChangeItem={this.onChangeItem}
        showArrows={true} //{!!(this.state.isWheel && this.state.wheelState === "active")}
        slideMargin={"0.55rem"}
        direction={i18n.getDirection()}
        style={style}
        MagicRemoteStatus={this.isMagicRemoteActive}
        className={this.isRowFocused(0) ? "focused" : this.isCropped(0) ? "cropped" : "row"}
        isStarz={this.isStarzSubscription()}
        isAdmnSubLayout={window.location.pathname.startsWith("/admn/") ? true : false}
        brandImageUrl={this.getBrandUrl()}
        isBrand={
          (window.location.pathname.includes("brands/") ||
            window.location.pathname.includes("movies") ||
            window.location.pathname.includes("series") ||
            window.location.pathname.includes("brands") ||
            window.location.pathname.includes("arabic") ||
            window.location.pathname.includes("admn") ||
            window.location.pathname.includes("category") ||
            window.location.pathname.includes("kids")) &&
          true
        }
        isFromCategoriesModal={this.props.location.referrer === "/categoriesMenuPage"}
        sponsorBugText={i18n.get("global.adTech.sponsorBug.text")}
        sponsorBugFallback={i18n.get("global.adTech.sponsorBug.defaultText")}
        sendImpression={url => impressionTracking(url)}
      />
    );

    const fullCatalogLayout = () => (
      <div style={style}>
        <ButtonStyled
          label={i18n
            .get(
              "pages.layout.exploreAll",
              this.state.displayName || i18n.get(`global.sections.${this.state.nameSection}`)
            )
            .toUpperCase()}
          size="small"
          carouselIndex={index}
          onClick={this.openFullCatalogLayout}
          // background={
          //   this.state.nameSection !== "kids" && `${config.get().ui.urlCdn}/MainMenu/${this.state.nameSection}.jpg`
          // }
          className={this.isRowFocused(index) ? "focused" : this.isCropped(index) ? "cropped" : "row"}
        />
      </div>
    );

    const carouselLayout = (module, moduleIndex) => (
      <this.TypedCarouselStyledMemo
        onClickPoster={i => this.onClickRow(i, module.rowIndex)}
        key={module.id}
        // FIXME: Adapt module type mapping to new types coming from new API (either 'Carousel' or 'cw')
        type={
          module.type && module.type.toLowerCase() === "cw"
            ? "watchlist"
            : module.type && module.type.toLowerCase() === "channels"
            ? "channels"
            : module.type && module.type.toLowerCase() === "livechannels"
            ? "LiveChannels"
            : module.type === "List5Items"
            ? "List5Items"
            : module.type === "List5Org"
            ? "List5Org"
            : module.type === "List5TopT" //FIXME: Need to disable this feature to LG Older Models
            ? "List5TopT"
            : module.type === "List5TopW"
            ? "List5TopW"
            : module.type === "List5Category"
            ? module.imageType === "PST"
              ? "layout"
              : module.imageType === "LANDSCAPE" && "List5Org"
            : module.type === "List5News"
            ? "List5News"
            : "layout"
        }
        items={getTitlesFormattedForCarousels.call(this, module.type, module.titles, module)}
        title={
          module.type &&
          module.type.toLowerCase() !== "hero" &&
          this.state.nameSection !== "live" &&
          module.type !== "LiveChannels"
            ? module.title
            : ""
        }
        iconTitle={module.type === "LiveChannels" && module.layoutOrder !== 0 ? "live" : ""}
        carouselIndex={index}
        initialSlide={this.getInitialSlide(moduleIndex)}
        onRef={this.onRefCarousel}
        onChangeItem={this.onChangeItem}
        MagicRemoteStatus={this.isMagicRemoteActive}
        slideMargin={Theme.components.carousel.slideMargin.layout}
        marginBottom={module.type && module.type.toLowerCase() === "cw" && (props => props.theme.spacing.small)}
        direction={i18n.getDirection()}
        showArrows={true} // {!!(this.state.isWheel && this.state.wheelState === "active")}
        style={style}
        isBrand={
          window.location.pathname.includes("brands/") || (window.location.pathname.startsWith("/admn/") && true)
        }
        isFromCategoriesModal={this.props.location.referrer === "/categoriesMenuPage"}
        slideMarginStartLive={
          this.state.nameSection !== "live" &&
          module.type === "LiveChannels" &&
          resolution.carousel.slideMarginStart.homeLive
        }
        isHomePage={this.props.name?.toLowerCase() === "home" ? true : false}
        className={
          this.isRowFocused(index)
            ? `focused ${
                module.type && module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : this.isCropped(index)
            ? `cropped ${
                module.type && module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : `row ${
                module.type && module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
        }
        imageType={module.type === "List5Category" || module.type === "List5News" ? module.imageType : ""}
      />
    );

    const getLayoutRow = index => {
      /** As per the new UI revamp(Android theme) need to place Explore button end of the page , so prevoius logics has to be scrapped. Prevously placed after the first row in grid layout.
       * if (index === 1 && this.state.nameSection !== "home")
       **/
      const { history } = this.props;
      const isSpecialLayout = !!(
        this.state.nameSection === "home" ||
        isADMNRoute(history.location.pathname) ||
        history.location.pathname.includes("category")
      );
      const moduleData = this.state.modules?.modules[index];
      if (
        moduleData?.id === this.cache._rowHeightCache[moduleData?.id] &&
        index === amountOfDownloadedModules[this.state.nameSection] &&
        !isSpecialLayout
      ) {
        return fullCatalogLayout();
      } else {
        // /*const moduleIndex = this.state.nameSection !== "home" && index > 1 ? index - 1 : index;*/
        const moduleIndex = index;
        const module = this.state.modules?.modules[moduleIndex];
        this.state.modules.modules[moduleIndex].rowIndex = index;
        if (module.type?.toLowerCase() === "hero") {
          return heroLayout();
        } else {
          return carouselLayout(module, moduleIndex);
        }
      }
    };

    return (
      this.isEnabled() && (
        <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
          {getLayoutRow(index)}
        </CellMeasurer>
      )
    );
  }

  getScrollTop(index, height) {
    // FIXME: memoization.
    if (!height || this.cache._cellHeightCache[0] === undefined) {
      return undefined;
    } else if (this.scrollPositions[index]) {
      return this.scrollPositions[index];
    }
    const stopY =
      index > 0
        ? new Array(index)
            .fill(undefined)
            .reduce(
              (prev, current, currentIndex) =>
                prev + this.cache._cellHeightCache[this.cache._keyMapper(currentIndex)] || 0,
              0
            )
        : 0;

    const scrollTop = Math.max(
      stopY - height / 2 + (this.cache._cellHeightCache[this.cache._keyMapper(index)] / 2 || 0),
      0
    );

    this.scrollPositions[index] = scrollTop;
    this.props.stateActions.setLayoutScrollTop(scrollTop);
    return scrollTop;
  }

  isScrollEnd() {
    const { history } = this.props;
    const isSpecialLayout = !!(
      this.state.nameSection === "home" ||
      isADMNRoute(history.location.pathname) ||
      history.location.pathname.includes("category")
    );
    const modulesLength = this.state.modulesActualLength ? this.state.modules.modulesActualLength : 0;
    if (!isSpecialLayout) {
      return this.state.scrollToIndex === modulesLength;
    }
    return this.state.scrollToIndex + 1 === modulesLength;
  }

  rowHeightCalculator({ index }) {
    const currentModule = this.state.modules?.modules[index];
    if (currentModule?.type === "LiveChannels") {
      return resolution.live.liveChannelCarouselHeight;
    }
    return this.cache._rowHeightCache[currentModule?.id]
      ? this.cache._rowHeightCache[currentModule?.id]
      : this.cache.rowHeight(index);
  }

  redirectToBuyBrandsFromBanner() {
    const {
      applicationState: { userLogged }
    } = this.props;
    const ageRestriction =
      this.currentProfile?.profileCategory === "KIDS" || Number(this.currentProfile?.parentalControl) <= 7;
    if (ageRestriction) {
      return showContentNotAccessibleModal.call(this, this.closeGlobalModal, {
        isSVODContent: true,
        name: this.brandName
      });
    } else if (userLogged) {
      showSubscriptionModal.call(this, this.brandName, true, null, null, isChampionsTrophyPage);
      return;
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeSignUpModal);
    }
  }

  /**
   * Callback to execute when toggle the application on background
   */
  onVisibilityChange() {
    if (document.hidden) {
      // pause app
      // do nothing
    } else {
      // resume app
      // need to call the dynamic modules again to get the latest data especially for NEWS/ZAK Carousel
      this.setState({ isLoaded: false }, async () => {
        await this.getLayout({ onlyNewsCarouselsFetch: true });
        this.setState({ isLoaded: true });
      });
    }
  }

  render() {
    const { scrollToIndex, modulesActualLength, isActiveBrand, priceObj } = this.state;
    const { location } = this.props;
    const isLoadedEnabled = this.isEnabled();
    const lastModule = this.isScrollEnd() ? ` isLayoutEnd` : ``;
    const hasStickyLabel = getStickyLabelForCurrentLayout() || location?.state?.title;
    const UpArrowStyles = {
      display: this.isMagicRemoteActive && this.state.isWheel && this.state.scrollToIndex > 0 ? "block" : "none"
    };
    const DownArrowStyles = {
      display:
        this.isMagicRemoteActive && this.state.isWheel && this.state.scrollToIndex >= -1 && !this.isScrollEnd()
          ? "block"
          : "none"
    };
    this.state.isLastRowHeightCache && this.clearRowHeightCache();

    return (
      <>
        {this.state.isLoaded && isLoadedEnabled ? (
          <>
            <LayoutStyled
              className={
                this.state.isLoaded &&
                isLoadedEnabled &&
                `hasContent${scrollToIndex > 0 ? ` isLayoutScrolling${lastModule}` : ``} ${!this.state.hasHeroModule &&
                  "noHero"}`
              }
              position={
                !this.state.hasHeroModule
                  ? resolution.layout.positionHeaderHidden
                  : resolution.layout.positionHeaderVisible
              }
              isActive={isActiveBrand}
              isHeroAndBanner={noHeader && !isActiveBrand && this.brandName && priceObj && !this.state.hasHeroModule}
            >
              <>
                {/*this.brandName !== "brands" && (
                  <ArrowScrollStyled
                    label={
                      this.props.applicationState.userLogged
                        ? i18n.get("pages.layout.searchAndMenu")
                        : i18n.get("pages.layout.loginAndMenu")
                    }
                    icon="arrowUp"
                    isVisible={this.state.scrollToIndex === 0}
                  />
                  )*/}
                <LayoutUpArrow
                  style={UpArrowStyles}
                  onWheel={e => {
                    this.setState({ isWheel: true });
                    this.scrollUpDown(e);
                  }}
                  onClick={() => this.slideUpDown("up")}
                >
                  <AirRemoteArrows arrowDirection={"up"}></AirRemoteArrows>
                </LayoutUpArrow>
                <LayoutDownArrow
                  className="arrowdown"
                  scrollToIndex={this.state.scrollToIndex}
                  style={DownArrowStyles}
                  onWheel={e => {
                    this.setState({ isWheel: true });
                    this.scrollUpDown(e);
                  }}
                  onClick={() => this.slideUpDown("down")}
                >
                  <AirRemoteArrows arrowDirection={"down"}></AirRemoteArrows>
                </LayoutDownArrow>

                {modulesActualLength > 0 ? (
                  <>
                    {this.state.hasHeroModule && this.state.mediaControlMenu && (
                      <MediaControlsListFocus
                        focusPath={"mediaControls"}
                        initialSlideIndex={location.state?.from?.index}
                        onRef={ref => (mediaSlider = ref)}
                        onLeft={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsRight
                            : this.onMediaControlsLeft
                        }
                        onRight={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsLeft
                            : this.onMediaControlsRight
                        }
                        onDown={this.onMediaControlsDown}
                        onUp={this.onMediaControlsUp}
                        onEnterPress={this.handleMediaControlsEnter}
                        mediaControlMenu={this.state.mediaControlMenu}
                      />
                    )}
                    {noHeader && !isActiveBrand && this.brandName && priceObj && (
                      <HeroBanner isActive={!isActiveBrand} className={`${!this.state.hasHeroModule && "noHero"}`}>
                        <ContainerStyled
                          ctaTextLength={
                            (priceObj.subscriptionDisplayName && priceObj.subscriptionDisplayName.length) || 0
                          }
                          flexTextRTL={true}
                        >
                          <ImageBannerStyled src={priceObj.logoImage} alt={this.brandName} />
                          <TextStyled
                            rank="3"
                            text={
                              isChampionsTrophyPage
                                ? `${priceObj.descHeaderTranslation} <br /> ${priceObj.pricingOnBannerTranslation}`
                                : `${priceObj.concatenatedString}`
                            }
                            size="small"
                            flexTextRTL={isChampionsTrophyPage ? false : true}
                          />
                        </ContainerStyled>
                        <ContainerButtonStyled
                          ctaTextLength={
                            (priceObj.subscriptionDisplayName && priceObj.subscriptionDisplayName.length) || 0
                          }
                        >
                          <ButtonBannerFocus
                            label={
                              isChampionsTrophyPage
                                ? i18n
                                    .get(
                                      `pages.layout.activationBanner.buttonAction.${priceObj.buttonDisplayName}`,
                                      priceObj.subscriptionDisplayName
                                    )
                                    .toUpperCase()
                                : priceObj?.planDisplayName
                                ? priceObj.planDisplayName
                                : i18n
                                    .get(`pages.brands.${priceObj.buttonDisplayName}`, priceObj.subscriptionDisplayName)
                                    .toUpperCase()
                            }
                            focusPath={bannerButtonFocusPath}
                            onEnterPress={this.redirectToBuyBrandsFromBanner.bind(this)}
                            onMouseUp={this.redirectToBuyBrandsFromBanner.bind(this)}
                            size="medium"
                            dataSnUp={""}
                            dataSnDown={`@${defaultFocusPath}`}
                            dataSnLeft={""}
                            dataSnRight={""}
                            icon={"open_lock"}
                            buttonType="primary"
                          />
                        </ContainerButtonStyled>
                      </HeroBanner>
                    )}
                    <ListFocus
                      onWheel={e => {
                        this.setState({ isWheel: true });
                        this.scrollUpDown(e);
                      }}
                      height={!this.state.hasHeroModule ? height - NO_HEADER_MARGIN_TOP_IN_PX : height}
                      width={width}
                      rowHeight={this.cache.rowHeight}
                      // rowHeight={this.rowHeightCalculator}
                      rowRenderer={this.rowRenderer}
                      rowCount={this.getListRowCount()}
                      columnCount={1}
                      deferredMeasurementCache={this.cache}
                      autoContainerWidth
                      scrollToIndex={scrollToIndex}
                      scrollToAlignment={"center"}
                      style={{ overflowY: "hidden", direction: "inherit" }}
                      overscanRowCount={1}
                      scrollingResetTimeInterval={0}
                      focusPath={defaultFocusPath}
                      onDown={() => this.onModulesDown(true)}
                      onUp={() => this.onModulesUp(true)}
                      onLeft={this.onModulesLeft}
                      onRight={this.onModulesRight}
                      onEnterPress={this.handleEnter}
                    />
                  </>
                ) : (
                  <LayoutEmptyStyled>
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph1")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph2")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph3")} />
                  </LayoutEmptyStyled>
                )}
              </>
            </LayoutStyled>
            {hasStickyLabel && <StickyLabel stickyLabelName={hasStickyLabel} />}
            {this.carouselToShowBack && (
              <Toast
                text={i18n.get("pages.layout.backToTop")}
                icon={"remoteBack"}
                size={"small"}
                onClick={this.goTop}
                isVisible={this.state.scrollToIndex > this.carouselToShowBack}
                isIndicator
              />
            )}
            <ShadowLayoutStyled />
          </>
        ) : (
          <Loading overlay opacity="0" />
        )}

        {this.state.modal4K && (
          <ModalSettings headingText={""} mainText={i18n.get("global.4Ksupported")}>
            <ButtonModalFocus
              label={i18n.get("global.play4K")}
              focusPath="play4KModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, true)}
              onMouseUp={this.onEnterPlay.bind(this, true)}
              size="small"
              onRef={ref => (this.play4KModalFocusPath = ref)}
              buttonType={"primary"}
              displayBlock={true}
              dataSnUp={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnDown={i18n.directionFlip("@playHDModal_passThru", "")}
              dataSnLeft={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnRight={i18n.directionFlip("@playHDModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.playHD")}
              focusPath="playHDModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, false)}
              onMouseUp={this.onEnterPlay.bind(this, false)}
              size="small"
              buttonType={"primary"}
              displayBlock={true}
              dataSnUp={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnDown={i18n.directionFlip("", "@play4KModal_passThru")}
              dataSnLeft={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@play4KModal_passThru")}
            />
          </ModalSettings>
        )}
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <ModalSettings
            headingText={i18n.get("global.modals.exit.title")}
            mainText={i18n.get("global.modals.exit.text")}
          >
            <ButtonModalFocus
              label={i18n.get("global.no").toUpperCase()}
              focusPath="noOkModal_passThru"
              onEnterPress={this.closeConfirmModal}
              onMouseUp={this.closeConfirmModal}
              size="small"
              spacing="small"
              displayBlock={true}
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnDown={"@okModal_passThru"}
              dataSnUp={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
            <ButtonModalFocus
              label={i18n.get("global.yes").toUpperCase()}
              focusPath="okModal_passThru"
              onEnterPress={this.appNeedToClose}
              onMouseUp={this.appNeedToClose}
              size="small"
              displayBlock={true}
              dataSnUp={"@noOkModal_passThru"}
              dataSnDown={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
          </ModalSettings>
        )}
      </>
    );
  }
}

const Component = withAppState(
  withSubtheme(props => <Layout currentFocus={props.applicationState.currentFocus} {...props} />)
);

Component.defaultFocusPath = defaultFocusPath;

export default Component;
